import LandingLayout from "./LandingLayoutRedesign";
import Profile from "../Profile";

const LandingProfilePage = () => (
  <LandingLayout>
    <Profile />
  </LandingLayout>
);

export default LandingProfilePage;
